import { Controller } from "@hotwired/stimulus"

/** Auto-dismiss flash alerts after duration; pause countdown while hovered. */
export default class extends Controller {
  static targets = ["progress"]
  static values = { durationMs: { type: Number, default: 5000 } }

  connect() {
    if (!this.hasProgressTarget) return

    const r = parseFloat(this.progressTarget.getAttribute("r") || "9")
    this.circumference = 2 * Math.PI * r
    this.progressTarget.style.strokeDasharray = `${this.circumference} ${this.circumference}`
    this.progressTarget.style.strokeDashoffset = "0"

    this.remainingMs = this.durationMsValue
    this.lastTs = null
    this.paused = false
    this.rafId = null

    this.onEnter = () => {
      this.paused = true
    }
    this.onLeave = () => {
      this.paused = false
    }
    this.element.addEventListener("mouseenter", this.onEnter)
    this.element.addEventListener("mouseleave", this.onLeave)

    this.boundTick = this.tick.bind(this)
    this.rafId = requestAnimationFrame(this.boundTick)
  }

  disconnect() {
    if (this.rafId != null) cancelAnimationFrame(this.rafId)
    this.element.removeEventListener("mouseenter", this.onEnter)
    this.element.removeEventListener("mouseleave", this.onLeave)
  }

  tick(ts) {
    if (this.lastTs == null) this.lastTs = ts
    const dt = ts - this.lastTs
    this.lastTs = ts

    if (!this.paused) {
      this.remainingMs -= dt
      if (this.remainingMs <= 0) {
        this.dismiss()
        return
      }
      const frac = Math.max(0, this.remainingMs / this.durationMsValue)
      this.progressTarget.style.strokeDashoffset = String(this.circumference * (1 - frac))
    }

    this.rafId = requestAnimationFrame(this.boundTick)
  }

  dismiss() {
    if (this.rafId != null) {
      cancelAnimationFrame(this.rafId)
      this.rafId = null
    }
    const btn = this.element.querySelector('[data-dismiss="alert"]')
    if (btn) btn.click()
    else this.element.remove()
  }
}
